/**
 * AppShell.tsx — prince-ui App-Hülle für MACO PIPELINE.
 *
 * Ersetzt die UI5-ShellBar + aside-Layout durch prince-ui `AppShell` + `Sidebar`.
 * Routing, Theme-Toggle und Keycloak-User-Menü bleiben erhalten; keine UI5-Imports.
 */

import { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { AppShell as PrinceAppShell } from "@conuti-das/prince-ui";
import { ReleaseProvider } from "@/context";
import { AppSideNavigation } from "./Sidebar";
import { HeaderActions, HeaderUserSlot, UserMenu } from "./Header";
import { LogoLockup } from "./LogoLockup";
import { OfflineBanner } from "@/components/common/OfflineBanner";
import { IdentityModal } from "@/components/identity/IdentityModal";

const SIDEBAR_COLLAPSED_KEY = "maco-status-sidebar-collapsed";

export function AppShell() {
  const nav = useNavigate();
  const [userMenuOpen, setUserMenuOpen] = useState(false);

  // Menü-Collapse über den AppShell-Toggle, in localStorage gemerkt.
  const [sidebarCollapsed, setSidebarCollapsed] = useState<boolean>(() => {
    if (typeof window === "undefined") return false;
    return window.localStorage.getItem(SIDEBAR_COLLAPSED_KEY) === "true";
  });
  useEffect(() => {
    window.localStorage.setItem(SIDEBAR_COLLAPSED_KEY, String(sidebarCollapsed));
  }, [sidebarCollapsed]);

  const sidebar = <AppSideNavigation />;

  // Der ReleaseProvider umschließt Kopfzeile UND <Outlet/>: Die Auswahl im Kopf
  // und alle Seiten lesen denselben Zustand. Er sitzt hier statt in main.tsx,
  // weil jede Route der App unter dieser Hülle liegt.
  return (
    <ReleaseProvider>
      <PrinceAppShell
        logo={<LogoLockup />}
        onLogoClick={() => nav("/")}
        actions={<HeaderActions />}
        user={<HeaderUserSlot />}
        onProfileClick={() => setUserMenuOpen((o) => !o)}
        sidebar={sidebar}
        sidebarCollapsed={sidebarCollapsed}
        onSidebarCollapsedChange={setSidebarCollapsed}
        toggleLabel="Menü ein-/ausklappen"
      >
        <OfflineBanner />
        <div
          style={{
            height: "100%",
            minWidth: 0,
            overflow: "auto",
            background: "transparent",
          }}
        >
          <Outlet />
        </div>
      </PrinceAppShell>

      {/* User profile menu (floating overlay) */}
      {userMenuOpen && <UserMenu onClose={() => setUserMenuOpen(false)} />}

      <IdentityModal />
    </ReleaseProvider>
  );
}
